import Panel from "./Panel";
import List from "./List";
import Item from "./Item";
import Factory from "./Factory";

const Nav = Factory;
Nav.Panel = Panel;
Nav.List = List;
Nav.Item = Item;

// export { Panel, List, Item };
export default Nav;
